export default "__VITE_ASSET__D1przv$u__"